import { ActionBar } from '@workwave-tidal/core/components'

import { ActionBarItem } from './ActionBarItem'
import { CurrencyValue } from './CurrencyValue'
import { DateValue } from './DateValue'
import { Description } from './Description'
import { DurationValue } from './DurationValue'
import { Field } from './Field'
import { Header } from './Header'
import { Label } from './Label'
import { LabelValueRow } from './LabelValueRow'
import { MixValue } from './MixValue'
import { MultipleValues } from './MultipleValues'
import { NullValue } from './NullValue'
import { SectionSubtitle } from './SectionSubtitle'
import { SectionTitle } from './SectionTitle'
import { TagsList } from './TagList/TagsList'
import { TagValue } from './TagValue'
import { Template } from './Template'
import { TimeWindow } from './TimeWindow'
import { Value } from './Value'
import { ViolationBadge } from './ViolationBadge'
import { ViolationContainer } from './ViolationContainer'
import { Violation } from './icons/Violation'

export const components = {
  ActionBar,
  ActionBarItem,
  CurrencyValue,
  DateValue,
  DurationValue,
  Field,
  Header,
  Label,
  MultipleValues,
  NullValue,
  SectionTitle,
  SectionSubtitle,
  TagValue,
  TagsList,
  TimeWindow,
  MixValue,
  Value,
  Template,
  ViolationBadge,
  ViolationContainer,
  LabelValueRow,
  icons: {
    Violation,
  },
  Description,
}
